const header = {
  "header.menu_01": "หน้าแรก",
  "header.menu_02": "ส่องเลนส์ Define®",
  "header.menu_03": "Filter ลองเลนส์",
  "header.menu_04": "ช้อปเลย",
  "header.list_menu_01": "ข้อมูลสินค้า",
  "header.list_menu_02": "Define® Classic",
  "header.list_menu_03": "Define® Fresh",
  "header.store_locator": "ร้านค้าใกล้คุณ",
  "header.store_01": "Lazada",
  "header.store_02": "Qoo10",
  "header.store_03": "Shopee",
}

export default header
